<head>
  <title>More Reports</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="col-md-8 " *ngIf="qmsservice.reportFor == 'Product Report'">
    <div class="row">
      <div class="col-md-3" *ngIf="qmsservice.moduleName =='CC'">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <br> <br> <br> <br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8 " *ngIf="qmsservice.reportFor == 'Activity Vs User'">
    <div class="row">

      <div class="col-md-3">
        <div><label for="email" id="userName"><b> User Name</b>: </label></div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
            [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChange($event,'userName')"
            placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction()"></span>
        </div>
      </div>
    </div>
    <br> <br> <br> <br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8 " *ngIf="qmsservice.reportFor == 'Performance'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label id="fromDateAlert" for="email"><b>From Date</b> <span class="mandatory-symbol">*</span>: </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate"
          (ngModelChange)="onNgModelChange($event,'fromDateAlert')">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <label for="email" id="toDateAlert"><b>To Date</b><span class="mandatory-symbol">*</span> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate"
          (ngModelChange)="onNgModelChange($event,'toDateAlert')">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2">
        <div><label for="email"><b>Stage</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedStageValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="selectedStageValue" matInput
            placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onStageValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of stageValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onStageValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <div><label for="email"><b>Status</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedStatusValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="selectedStatusValue" matInput
            placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of statusValueDropdown1 | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>{{this.qmsservice.moduleName}} ID.</b> : </label></div>
        <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="activityId"
          placeholder="Enter ID">
      </div>
    </div>
    <br><br><br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Pending Actions'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="userName"><b> User Name</b><span class="mandatory-symbol">*</span>: </label></div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
            [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChange($event,'userName')"
            placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction()"></span>
        </div>
      </div>
    </div>
    <br> <br> <br> <br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Overdue'">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div class="col-md-10">
          <label for="email" id="overDue"><b>Over Due </b><span class="mandatory-symbol">*</span> :</label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedOverDue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onOverDueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of overDueDropDown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onOverDueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Extension'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="dateRange1"><b>Date Range</b><span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedExtensionDate" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onExtensionSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of extensionDateDropDown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onExtensionSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
    </div>
    <br><br><br>
    &nbsp;&nbsp;
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Effectiveness Check'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="dateRange"><b>Date Range</b><span class="mandatory-symbol">*</span> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedUpdateDate" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of updateDateDropDown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
    </div>
    <br><br><br>&nbsp;
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Action'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="dateRange2"><b>Date Range</b><span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedActionDate" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect1($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of actionDateDropDown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect1($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
    </div>
    <br><br><br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Deleted'">
    <div class="col-md-3">
      <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
      </div>
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
        (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
        <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
        <mat-option [value]="null" class="unselectStyle"
          (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
          (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
    <br><br><br>
    <div class="row" d-flex align-items-center>

      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Obsoleted'">
    <div class="col-md-3">
      <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
      </div>
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
        (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
        <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
        <mat-option [value]="null" class="unselectStyle"
          (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
          (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
    <br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Milestone'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" [disabled]="isDropdownDisabled">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="teaskView"><b> Task ID</b>: </label></div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
            [(ngModel)]="getSelectedTaskId" placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchTaskVwFunction()"></span>
        </div>
      </div>
      <div class="col-md-2" *ngIf="qmsservice.moduleName !='CC'">
        <div><label for="email" id="TaskTypeAlert"><b>Task Type</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTaskTypeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of changeTypeDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <br><br><br>
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>

    <!-- First row -->
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Default'}" (click)="moreActivityReportDetails('Default')">
          <div class="reports_block">
            <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
          </div>
          <p class="report_subtext">Default</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Performance'}"
          (click)="moreActivityReportDetails('Performance')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="CR Performance">
          </div>
          <p class="report_subtext">{{qmsservice.moduleName}} Performance</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Pending Actions'}"
          (click)="moreActivityReportDetails('Pending Actions')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/pending.svg" width="16px" height="16px" alt="Pending Actions">
          </div>
          <p class="report_subtext">Pending Actions</p>
        </div>
      </div>
    </div>

    <!-- Second row -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
          (click)="moreActivityReportDetails('Extension')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
          </div>
          <p class="report_subtext">Extension</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='OOS' && qmsservice.moduleName !='AU' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Effectiveness Check'}"
          (click)="moreActivityReportDetails('Effectiveness Check')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px"
              alt="Effectiveness check">
          </div>
          <p class="report_subtext">Effectiveness Check</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName =='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Product Report'}"
          (click)="moreActivityReportDetails('Product Report')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px" alt="Product Report">
          </div>
          <p class="report_subtext">Product Report</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Action'}" (click)="moreActivityReportDetails('Action')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Action">
          </div>
          <p class="report_subtext">Actions</p>
        </div>
      </div>
    </div>

    <!-- Third row (AU specific) -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Finding'}" (click)="auditFindingReportDetails('Finding')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/loupe.png" width="16px" height="16px" alt="Finding">
          </div>
          <p class="report_subtext">Finding</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Followup'}"
          (click)="auditFindingReportDetails('Followup')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/arrow.png" width="16px" height="16px" alt="Followup">
          </div>
          <p class="report_subtext">Followup</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Recommendation'}"
          (click)="auditFindingReportDetails('Recommendation')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/question.png" width="16px" height="16px" alt="Recommendation">
          </div>
          <p class="report_subtext" style="font-size: 8px;">Recommendation</p>
        </div>
      </div>
    </div>

    <!-- Fourth row (AU specific FindingDue, FollowupDue, Extension) -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'FindingDue'}" (click)="findingDueDate('FindingDue')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/date.png" width="16px" height="16px" alt="FindingDue">
          </div>
          <p class="report_subtext">Finding Due</p>
        </div>
      </div>
      <div class="col-md-4"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'FollowupDue'}" (click)="followupDueDate('FollowupDue')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/due-date.png" width="16px" height="16px" alt="FollowupDue">
          </div>
          <p class="report_subtext">Followup Due</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='IN'  && qmsservice.moduleName!='QI' ">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
          (click)="moreActivityReportDetails('Extension')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
          </div>
          <p class="report_subtext">Extension</p>
        </div>
      </div>
    </div>

    <!-- Fifth row: Overdue + Milestone -->
    <div class="row mt-4">
      <div class="col-md-4" *ngIf="qmsservice.moduleName =='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
          </div>
          <p class="report_subtext">Overdue</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
          </div>
          <p class="report_subtext">Overdue</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Milestone'}"
          (click)="moreActivityReportDetails('Milestone')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
          </div>
          <p class="report_subtext">Milestone</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Activity Vs User'}"
          (click)="moreActivityReportDetails('Activity Vs User')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="Activity Vs User">
          </div>
          <p class="report_subtext">Activity Vs User</p>
        </div>
      </div>
    </div>

    <!-- Sixth row: Expand/Collapse Button -->
    <div class="row mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report" (click)="toggleMore()" style="cursor: pointer;">
          <p class="report_subtext">
            {{ showMore ? 'Collapse Reports ◀' : 'Expand More ▶' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Seventh row: Obsoleted + Deleted (Only shown when expanded) -->
    <div class="row mt-2" *ngIf="showMore">
      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU' 
                              && qmsservice.moduleName !='CC' 
                              && qmsservice.moduleName !='IN' 
                              && qmsservice.moduleName !='QI'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Obsoleted'}"
          (click)="moreActivityReportDetails('Obsoleted')" style="cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/obsoleted.svg" width="16px" height="16px" alt="Obsoleted">
          </div>
          <p class="report_subtext">Obsoleted</p>
        </div>
      </div>

      <div class="col-md-4" *ngIf="qmsservice.moduleName !='AU'">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.reportFor === 'Deleted'}" (click)="moreActivityReportDetails('Deleted')"
          style="cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/delete.svg" width="16px" height="16px" alt="Deleted">
          </div>
          <p class="report_subtext">Deleted</p>
        </div>
      </div>
    </div>

  </div>
</div>
<!--Data view in tables-->
<hr>
<div class="table-container" *ngIf="showTables">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{this.qmsservice.moduleName}} {{qmsservice.reportFor}}</span>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Performance' && showNoRecordFoundPerformance">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Performance"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Performance'&& !showNoRecordFoundPerformance && tableReportPerformansDataList && tableReportPerformansDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Department Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('taskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Additional Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Requested At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('requestedAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Business Area</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('coreBusinessAreaName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Initiator</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiator', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName =='AU'">
            <span>Planner</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiator', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>Owner</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('owner', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName =='AU'">
            <span>Lead Auditor</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('owner', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName !='AU'">
            <span>QA User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('qa', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName =='AU'">
            <span>Plan Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('qa', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style"
            *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='AU'">
            <span>Investigator</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('investigator', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf=" qmsservice.moduleName !='AU'">
            <span>Reviewers</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reviewrs', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf=" qmsservice.moduleName !='AU'">
            <span>Approvers</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('approvers', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Reviewers</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('closureReviewrs', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Approvers</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('closureApprovers', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf="qmsservice.moduleName =='AU'">
            <span>Peer Reviewers</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('peerReviewers', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">
            <span>Expceted Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expcetedClosureOnStr', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data">{{ listOfUsersData.taskType }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.requestedAt }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName !='AU'">{{ listOfUsersData.coreBusinessAreaName }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">{{ listOfUsersData.initiator }}</td>
          <td class="row-data">{{ listOfUsersData.owner }}</td>
          <td class="row-data">{{ listOfUsersData.qa }}</td>
          <td class="row-data"
            *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='AU'">
            {{
            listOfUsersData.investigator }}</td>
          <td class="row-data" *ngIf=" qmsservice.moduleName !='AU'">{{ listOfUsersData.reviewrs }}</td>
          <td class="row-data" *ngIf=" qmsservice.moduleName !='AU'">{{ listOfUsersData.approvers }}</td>
          <td class="row-data">{{ listOfUsersData.closureReviewrs }}</td>
          <td class="row-data">{{ listOfUsersData.closureApprovers }}</td>
          <td class="row-data" *ngIf="qmsservice.moduleName =='AU'">{{ listOfUsersData.peerReviewers }}</td>

          <td class="row-data"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">{{
            listOfUsersData.startedOnStr }}</td>
          <td class="row-data"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">{{
            listOfUsersData.completedOnStr }}</td>
          <td class="row-data"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">{{
            listOfUsersData.expectedToBeStartedOnStr }}</td>
          <td class="row-data"
            *ngIf="qmsservice.moduleName =='CR' || qmsservice.moduleName =='CAPA' || qmsservice.moduleName =='DV'">{{
            listOfUsersData.expcetedClosureOnStr }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Pending Actions' && showNoRecordFoundPendingAction">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Pending Actions"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Pending Actions' && !showNoRecordFoundPendingAction && pendingActionList && pendingActionList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Current Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('currentStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>SubTask Current Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('subTaskCurrentStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Or Subtask Previous Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskOrSubtaskPreviousStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Other Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('otherDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Owner User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskOwnerUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Requester User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('requesterUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Operation</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('operation', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('actionRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Pending With User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('pendingWithUserNames', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Pending With Users Role</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('pendingWithUsersRole', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('dueOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Enabled</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('isEnabled', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>SubTask Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('subTaskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>SubTask Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('subTaskName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.taskName }}</td>
          <td class="row-data">{{ listOfUsersData.currentStatus}}</td>
          <td class="row-data">{{ listOfUsersData.subTaskCurrentStatus}}</td>
          <td class="row-data">{{ listOfUsersData.taskOrSubtaskPreviousStatus }}</td>
          <td class="row-data">{{ listOfUsersData.otherDetails }}</td>
          <td class="row-data">{{ listOfUsersData.taskOwnerUserName }}</td>
          <td class="row-data">{{ listOfUsersData.requesterUserName }}</td>
          <td class="row-data">{{ listOfUsersData.operation }}</td>
          <td class="row-data">{{ listOfUsersData.actionRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.pendingWithUserNames }}</td>
          <td class="row-data">{{ listOfUsersData.pendingWithUsersRole }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">{{ listOfUsersData.dueOnStr }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isEnabled === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isEnabled === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.subTaskType }}</td>
          <td class="row-data">{{ listOfUsersData.subTaskName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby="dropdownBasic6">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center"
        aria-labelledby="dropdownBasic6">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="row" *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0 && qmsservice.reportFor == 'Product Report'">
    <div class="table-container">
      <div class="row">
        <div class="col-6"></div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
          *ngIf="message.dataGridAdmin" (click)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
      </div>&nbsp;&nbsp;
      <div class="table-container">
        <table style="height: 60vh;">
          <thead>
            <th style="min-width: 60px; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            </th>
            <th id="grid-header-container"
              *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
              [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
              class="sticky-dynamic-col1 dynamic-table-header-style">
              <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
                <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                <div class="row-search-container">
                  <input type="text" class="form-control" placeholder="Search"
                    (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
                </div>
              </div>
            </th>
          </thead>
          <tr *ngIf="pagedItems.length === 0">
            <td class="row-data text-center" colspan="15">No records found</td>
          </tr>
          <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
            <td style="min-width: 60px; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
              <div style="display: flex;">
                <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div>
                  <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                    (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                </div>
              </div>
            </td>
            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
              class="sticky-dynamic-row1" [ngStyle]="{'min-width':'200px','max-width':'200px','overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
              <span *ngIf="key.dataType=='CHECKBOX'">
                <div class="gridCheckBoxes">
                  <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                    height="20">
                  <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" width="20"
                    height="20" alt="">
                </div>
              </span>
              <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="getClobData1(list,key.columnsListarray)">
                    <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                    <span class="ms-1" style="color:azure">View</span>
                  </button>
                </div>
              </span>
              <span
                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
                list[key.columnsListarray]}}</span>
              <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray]
                |
                date : (appService.getOneQmsDateFormat )}}</span>
              <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray]
                |
                date : (appService.getOneQmsDateFormat)}}</span>
              <span
                *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
                list[key.columnsListarray] }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="row border-top mt-1 width-cheat small paginationCell">
        <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>

        <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
          <div ngbDropdown class="d-inline-block leftpadding">
            <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic" ngbDropdownToggle>
              {{perPage}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </nav>
        <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Activity Vs User' && showNoRecordFoundPendingAction">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Pending Actions"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Activity Vs User' && !showNoRecordFoundPendingAction && pendingActionList && pendingActionList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>SubTask Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('subTaskName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Owner User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('taskOwnerUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Requester User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('requesterUserName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('actionRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Pending With User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('pendingWithUserNames', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('dueOnStr', $event,'d')" />
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.taskName }}</td>
          <td class="row-data">{{ listOfUsersData.subTaskName }}</td>
          <td class="row-data">{{ listOfUsersData.status}}</td>
          <td class="row-data">{{ listOfUsersData.taskOwnerUserName }}</td>
          <td class="row-data">{{ listOfUsersData.requesterUserName }}</td>
          <td class="row-data">{{ listOfUsersData.actionRequestedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.pendingWithUserNames }}</td>
          <td class="row-data">{{ listOfUsersData.dueOn}}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby="dropdownBasic6">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center"
        aria-labelledby="dropdownBasic6">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
            <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Extension' && showNoRecordFoundExtension">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Extension"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Extension' && !showNoRecordFoundExtension && extensionTableReportDataList && extensionTableReportDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('extensionId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Current Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('currentDueDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Required Till</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('extensionRequiredTillStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Justification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('justification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('reviewRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('reviewedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approve Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approveRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approvedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('approverComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter2('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Extension Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('extensionType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter1('actionDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems2.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.extensionId }}</td>
          <td class="row-data">{{ listOfUsersData.currentDueDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.extensionRequiredTillStr }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'JUSTIFICATION',listOfUsersData.justification,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REVIEW_COMMENTS',listOfUsersData.reviewComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approveRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVER_COMMENTS',listOfUsersData.approverComments,'QMS_ALL_TASK_EXTENSIONS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.extensionType }}</td>
          <td class="row-data">{{ listOfUsersData.actionDetails }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby="dropdownBasic6">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center"
        aria-labelledby="dropdownBasic6">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic3" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
            <button ngbDropdownItem (click)="paginationCall3(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall3(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall3(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Effectiveness Check' && showNoRecordFoundEffectiveness">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Effectiveness Check"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Effectiveness Check'&& !showNoRecordFoundEffectiveness && ecTableReportDataList && ecTableReportDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('taskId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('ecId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Duedate</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('dueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Methodology</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('methodology', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Criteria</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('criteria', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Conclusion</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('conclusion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Outcome</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('outcome', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('closureComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approvedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('qaApprovalRequestedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approved On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('qaApprovedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('qaApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('qaApprovalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Remind N Days Before Duedate</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('remindNDaysBeforeDueDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('createdByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Triggered From EC ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('triggeredFromEcId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Check Reqd For</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('checkReqdFor', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('ownerName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Start Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3('startDate', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems3.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems3; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.ecId }}</td>
          <td class="row-data">{{ listOfUsersData.dueDateStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'METHODOLOGY',listOfUsersData.methodology,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CRITERIA',listOfUsersData.criteria,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CONCLUSION',listOfUsersData.conclusion,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.outcome }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'CLOSURE_COMMENTS',listOfUsersData.closureComments,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVAL_COMMENTS',listOfUsersData.approvalComments,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approvedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprovedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.qaApprover}}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'QA_APPROVAL_COMMENTS',listOfUsersData.qaApprovalComments,'QMS_ALL_TASK_EC_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.remindNDaysBeforeDueDate }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.triggeredFromEcId }}</td>
          <td class="row-data">{{ listOfUsersData.checkReqdFor }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.ownerName }}</td>
          <td class="row-data">{{ listOfUsersData.startDateStr}}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage4(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic4" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
              <button ngbDropdownItem (click)="paginationCall4(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall4(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall4(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Action' && showNoRecordFoundAction">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Action" style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Action'&& !showNoRecordFoundAction && actionTableReportDataList && actionTableReportDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sl No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter4('slNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Target Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('targetDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Core Business Area</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('coreBusinessArea', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('assignedTo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Performed</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionPerformed', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Performed Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('performedActionDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Justification</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('justification', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Action Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('actionCompletedOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('reviewRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('reviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('reviewStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('reviewComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('reviewCompletedOnStr', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('approvalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('approver', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('approvalStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('approvalComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('approvalCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Reviewer</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('deferReviewer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Defer Approver</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('deferApprover', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('createdByUser', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter4('intervals', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems4.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems4; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.slNo }}</td>
          <td class="row-data">{{ listOfUsersData.actionId }}</td>
          <td class="row-data">{{ listOfUsersData.actionName }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'ACTION_DESCRIPTION',listOfUsersData.actionDescription,'QMS_ALL_TASK_ACTIONS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.targetDateStr }}</td>
          <td class="row-data">{{ listOfUsersData.actionAt }}</td>
          <td class="row-data">{{ listOfUsersData.coreBusinessArea }}</td>
          <td class="row-data">{{ listOfUsersData.assignedTo }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'COMMENTS',listOfUsersData.comments,'QMS_ALL_TASK_ACTIONS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.actionPerformed === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.actionPerformed === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.performedActionDetails }}</td>
          <td class="row-data">{{ listOfUsersData.justification }}</td>
          <td class="row-data">{{ listOfUsersData.actionCompletedOn }}</td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.reviewer }}</td>
          <td class="row-data">{{ listOfUsersData.reviewStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REVIEW_COMMENTS',listOfUsersData.reviewComments,'QMS_ALL_TASK_ACTIONS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.approver }}</td>
          <td class="row-data">{{ listOfUsersData.approvalStatus }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'APPROVAL_COMMENTS',listOfUsersData.approvalComments,'QMS_ALL_TASK_ACTIONS_INTERVAL_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.deferReviewer }}</td>
          <td class="row-data">{{ listOfUsersData.deferApprover }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic5" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
              <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Overdue' && showNoRecordFoundOverdue">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="Overdue" style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Overdue'&& !showNoRecordFoundOverdue && tableReportDataList && tableReportDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Department Code</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('deptCode', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Requested At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('requestedAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Business Area</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('coreBusinessAreaName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('expcetedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('ownerFullname', $event,'scheduleNo')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('qaFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Effectiveness Check Reqd.</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('effectivenessCheckReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems5.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.deptCode }}</td>
          <td class="row-data">{{ listOfUsersData.requestedAt }}</td>
          <td class="row-data">{{ listOfUsersData.coreBusinessAreaName }}</td>
          <td class="row-data">{{ listOfUsersData.expcetedClosureOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.ownerFullname }}</td>
          <td class="row-data">{{ listOfUsersData.qaFullname }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby="dropdownBasic6">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center"
        aria-labelledby="dropdownBasic6">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
            <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor == 'Deleted' || qmsservice.reportFor == 'Obsoleted'">
    <div class="table-container" *ngIf="showNoRecordFoundDeleted || showNoRecordFoundObsoleted">
      <span
        style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
        <img src="../../assets/img/empty-box.png" alt="Group Intervals"
          style="width: 100px; height: 100px; margin-right: 10px;">
        <br> No record found
      </span>
    </div>
    <div
      *ngIf="!showNoRecordFoundDeleted && !showNoRecordFoundObsoleted && tableReportDataList && tableReportDataList.length > 0">
      <div class="row">
        <div class="col-8"></div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
      </div>
      <div class="table-container">
        <table style="height: 60vh;">
          <thead style="z-index:9">
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>{{this.qmsservice.moduleName}} ID</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('taskId', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>{{this.qmsservice.moduleName}} Description</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('shortDescription', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Department Code</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('deptCode', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Requested At</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('requestedAt', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Business Area</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('coreBusinessAreaName', $event,'s')" />
              </div>
            </th>

            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Owner</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('ownerFullname', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>QA User</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('qaFullname', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Started On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('startedOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Completed On</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('completedOnStr', $event,'d')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Status</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('status', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Stage Name</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('stageName', $event,'s')" />
              </div>
            </th>
            <th class="sticky-dynamic-col1 dynamic-table-header-style">
              <span>Effectiveness Check Reqd.</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter5('effectivenessCheckReqd', $event,'s')" />
              </div>
            </th>

            <th class="sticky-col first-col"></th>
          </thead>
          <tr *ngIf="pagedItems5.length === 0">
            <td class="row-data text-center" colspan="15">No records found</td>
          </tr>
          <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
            <td class="row-data">{{ listOfUsersData.taskId }}</td>
            <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
            <td class="row-data">{{ listOfUsersData.deptCode }}</td>
            <td class="row-data">{{ listOfUsersData.requestedAt }}</td>
            <td class="row-data">{{ listOfUsersData.coreBusinessAreaName }}</td>
            <td class="row-data">{{ listOfUsersData.ownerFullname }}</td>
            <td class="row-data">{{ listOfUsersData.qaFullname }}</td>
            <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
            <td class="row-data">{{ listOfUsersData.status }}</td>
            <td class="row-data">{{ listOfUsersData.stageName }}</td>
            <td class="row-data">
              <div class="icon-container">
                <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                  width="20" height="20" alt="Access granted symbol">
                <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'N'" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" alt="Access granted symbol">
              </div>
            </td>

          </tr>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
                <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="qmsservice.reportFor=='Milestone' && showNoRecordFoundMileStone">
    <span
      style="width: 100%; height: 220px; display: block; text-align: center; font-weight: bold; font-size: 24px; background: transparent;">
      <img src="../../assets/img/empty-box.png" alt="MileStone"
        style="width: 100px; height: 100px; margin-right: 10px;">
      <br> No record found
    </span>
  </div>
  <div class="table-container"
    *ngIf="qmsservice.reportFor == 'Milestone'&& !showNoRecordFoundMileStone && tableReportDataList && tableReportDataList.length > 0">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('taskId', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('currentStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>{{this.qmsservice.moduleName}} Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('taskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('reviewRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('reviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('approvalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Approval Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('approvalCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Review Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureReviewRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Review Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureReviewCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Approval Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureApprovalRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Closure Approval Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('closureApprovalCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('startedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('completedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sign off Requested On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('signoffRequestedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sign off Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter5('signoffCompletedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems5.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.currentStatus }}</td>
          <td class="row-data">{{ listOfUsersData.taskType }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.closureReviewRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.closureReviewCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.closureApprovalRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.closureApprovalCompletedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.startedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.completedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.signoffRequestedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.signoffCompletedOnStr }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby="dropdownBasic6">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center"
        aria-labelledby="dropdownBasic6">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
            <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<ng-template #searchTaskVW>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAllTaskVwFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <table class="search-manager-table-container">
      <th style="min-width: 80px; text-align: center;">
        <div style="display: flex;">
          <div>
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;">
          </div>
        </div>
      </th>
      <th> <span>Task ID</span> <span class="fa-solid fa-filter"></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskId', $event)" />
      </th>
      <th> <span>Task Details</span> <span class="fa-solid fa-filter"></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskDetails', $event)" />
      </th>
      <tr class="data-row-container" *ngFor="let listOfUsersVwDetails of getTaskDetailsObj1; let idx = index;"
        [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
        <td style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                (change)="searchTaskVwChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
            </div>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersVwDetails.taskId }}</td>
        <td class="row-data">{{ listOfUsersVwDetails.taskDetails }}</td>
      </tr>
    </table>
  </div>
  <div class="row">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addTaskVwGridDataFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelAllTaskVwFunction()">
        <i class="fa fa-repeat"></i> cancel
      </button>
    </div>
  </div>
</ng-template>
<!--dynamic popup-->
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">More Activity Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onDesignationCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onDepartmentCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchManagerGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
            </div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Contact Number</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Ad User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Factory User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Active</span> <span class="fa-solid fa-filter"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;"
          [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                  (change)="searchManagerChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isAdUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isFactoryUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isActive"> </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addManagerNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--dynamic popup-->
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">More Activity Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')">
              <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection1('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{item.displayExp}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>